import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '../../../services/analytics.service';

/**
 * this compenent will create an chartsjs multi line chart with sessions and avg durations
 */
@Component({
  selector: 'app-multi-line-sessions-and-avg-durations',
  templateUrl: './multi-line-sessions-and-avg-durations.component.html',
  styleUrl: './multi-line-sessions-and-avg-durations.component.scss',
})
export class MultiLineSessionsAndAvgDurationsComponent {
  isLoading = true;

  options: echarts.EChartsOption = {
    grid: { left: 40, right: 30, top: 40, bottom: 80 },
    yAxis: [
      {
        type: 'value',
        position: 'left',
        name: this.translateService.instant('charts.labels.seconds'),
        nameLocation: 'middle', // position along axis (top | middle | bottom)
        nameGap: 40, // distance from axis
        nameTextStyle: {
          fontSize: 12,
          fontWeight: 'bold',
        },
      },
      {
        type: 'value',
        position: 'right',
        name: this.translateService.instant('charts.labels.count'),
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: {
          fontSize: 12,
          fontWeight: 'bold',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 1,
        itemStyle: {
          color: '#6FFACC',
          borderColor: '#6FFACC',
          borderWidth: 4,
        },
      },
      {
        type: 'bar',
        yAxisIndex: 0,
        itemStyle: {},
      },
    ],
  };

  constructor(
    protected analyticsService: AnalyticsService,
    public translateService: TranslateService
  ) {
    this.analyticsService.multiLineSessionsAndAvgDurations$.subscribe(
      (data) => {}
    );
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('multiLineSessionsAndAvgDurations');
    });
    this.getChartData();
  }

  getChartData() {
    this.isLoading = true;
    this.analyticsService.getMultiLineSessionsAndAvgDurations().subscribe();
  }

  get series() {
    return this.analyticsService.multiLineSessionsAndAvgDurations$.value
      ?.series;
  }

  get labels() {
    return this.analyticsService.multiLineSessionsAndAvgDurations$.value
      ?.labels;
  }
}
